import axios from "axios";
import { getErrorLabel } from "../jsx/components/Util/errorMessage";
import Cookies from 'js-cookie';
import { registraErroreServer, azzeraErroreServer } from "../jsx/components/Util/erroreServer";
import { importiInNumeri } from "../jsx/components/Util/prezzi";
// Vista struttura del super admin: installa il suo intercettore (header e sola lettura)
import "../jsx/components/Util/vistaStruttura";
import { MESSAGGIO_CARICAMENTO_NON_RIUSCITO } from "../jsx/components/Util/limiteFile";

// Il motivo degli errori del server resta a disposizione delle pagine
// (conMotivo in Util/erroreServer): ogni scrittura riparte da zero.
axios.interceptors.request.use((config) => {
    if (config.method && config.method.toLowerCase() !== 'get') {
        azzeraErroreServer();
        // Gli importi scritti con la virgola («25,50») partono come numeri.
        if (typeof config.data === 'string' && config.data.charAt(0) === '{') {
            try {
                const dati = JSON.parse(config.data);
                const convertiti = importiInNumeri(dati);
                if (convertiti !== dati) config.data = JSON.stringify(convertiti);
            } catch (e) { /* corpo non JSON: si lascia com'è */ }
        } else {
            config.data = importiInNumeri(config.data);
        }
    }
    return config;
});
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const dati = error && error.response && error.response.data;
        const dettaglio = dati && (dati.detail || dati.message || (typeof dati === 'string' ? dati : null));
        if (dettaglio) registraErroreServer(getErrorLabel(dettaglio));
        return Promise.reject(error);
    }
);

// Il tipo degli export XLSX. Va chiesto nell'Accept: API Gateway decide se la
// risposta e' binaria guardando l'Accept della richiesta e ne legge solo il primo
// valore, quindi con `application/json` il foglio arriverebbe come testo base64.
const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

// Profilo che il super admin sta modificando (userId): impostato dalle schede delle anagrafiche, vuoto altrove.
let profiloDiModifica = null;
export const impostaProfiloDiModifica = (userId) => { profiloDiModifica = userId || null; };
export const profiloInModifica = () => profiloDiModifica;

// Con la scheda di un utente aperta, le modifiche a titoli, documenti, galleria, foto, copertine e tesserini
// valgono per lui: il backend le accetta dal super admin con `?userId=` («modifiche 12 ottobre», 3.2).
const SOTTO_RISORSE_DEL_PROFILO = /\/profile\/(titles|documents|gallery|pictures|covers|taughtSports)(\/|$)/;
axios.interceptors.request.use((config) => {
    if (!profiloDiModifica || !config.url) return config;
    if ((config.method || 'get').toLowerCase() === 'get') return config;
    const [percorso, query = ''] = String(config.url).split('?');
    // Anche chi salva il profilo con PATCH /profile diretto (es. salvaOpzioniScheda) va sulla rotta del super admin
    if ((config.method || '').toLowerCase() === 'patch' && /\/profile$/.test(percorso)) {
        config.url = `${percorso.replace(/\/profile$/, '')}/administration/profiles/${encodeURIComponent(profiloDiModifica)}${query ? `?${query}` : ''}`;
        return config;
    }
    if (!SOTTO_RISORSE_DEL_PROFILO.test(percorso)) return config;
    if (/(^|&)userId=/.test(query) || (config.params && config.params.userId)) return config;
    config.params = { ...(config.params || {}), userId: profiloDiModifica };
    return config;
});

export default class MyApiClient {
    constructor() {
        this.basePath = process.env.REACT_APP_API_BASE_PATH.replace(/\/+$/, '');
        this.backOfficeBasePath = process.env.REACT_APP_BACKOFFICE_BASE_PATH.replace(/\/+$/, '');
        this.auth2fa = process.env.REACT_APP_AUTH_2FA;
    }

    async loginWithout2Fa(username, password) {
        const url = `${this.basePath}/auth/login`;
        
        let auth2fa = false;

        const payload = {
            username: username,
            password: password,
            auth2fa: auth2fa
        };

        try {
            const response = await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            if (response.status === 200) {
                return response.data;
            } else {
                return { error: 'Errore generico durante l\'operazione (stato '+response.status+')' };
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData);
                
                // Per errori di validazione, restituisci l'intera risposta
                if (errorResponseData.type && errorResponseData.type.includes('validation-error')) {
                    return {error: `Response: ${JSON.stringify(errorResponseData)}`};
                }
                
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async login(username, password) {
        const url = `${this.basePath}/auth/login`;
        
        // 2FA temporaneamente disabilitata anche in produzione
        let auth2fa = false;
        // if (typeof window !== 'undefined' && window.location.hostname === 'manager.sportid.it') {
        //     auth2fa = true;
        // }

        const savedAt = Cookies.get('login_2fa_at');
        if (savedAt) {
            const savedTime = parseInt(savedAt);
            const now = Date.now();
            const diff = now - savedTime;
            const isWithin24Hours = diff <= 24 * 60 * 60 * 1000;
            if (isWithin24Hours) {
                //console.log('DATO salvato nelle ultime 24 ore');
                if(auth2fa) {
                    auth2fa = false;
                }
            }
        }

        const payload = {
            username: username,
            password: password,
            auth2fa: auth2fa
        };

        try {
            const response = await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            if (response.status === 200) {
                return response.data;
            } else {
                return { error: 'Errore generico durante l\'operazione (stato '+response.status+')' };
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData);
                
                // Per errori di validazione, restituisci l'intero oggetto di errore
                if (errorResponseData.type && errorResponseData.type.includes('validation-error')) {
                    return {error: JSON.stringify(errorResponseData)};
                }
                
                // Un errore resta un errore anche senza testo: con il detail vuoto (login dal 23/10/2026) la pagina
                // andava avanti come se l'accesso fosse riuscito e mostrava «AxiosError 401»
                return {error: errorResponseData.detail || errorResponseData.title || 'Errore generico'};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async login2fa(userId, code2fa) {
        const url = `${this.basePath}/auth/login/2fa`;
        
        const payload = {
            userId: userId,
            code2fa: code2fa
        };

        try {
            const response = await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            if (response.status === 200) {
                return response.data;
            } else {
                return { error: 'Errore generico durante l\'operazione (stato '+response.status+')' };
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async register(nomeStruttura, tipoStruttura, tipoSubStruttura, email, password) {
        const url = `${this.basePath}/auth/signup`;
        
        const payload = {
            user: {
                club: {
                    clubNature: tipoStruttura,
                    clubSubNature: tipoSubStruttura,
                    email: email,
                    locale: 'it-IT',
                    name: nomeStruttura
                }
            },
            password: password
        };

        try {
            const response = await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            if (response.status === 200 || response.status === 201) {
                return response.data;
            } else {
                return { error: 'Errore generico durante l\'operazione (stato '+response.status+')' };
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: getErrorLabel(errorResponseData.detail)};
            } else {
                return {error: 'Errore generico durante l\'operazione'};
            }
        }
    }

    async registerOnlyEmail(nomeStruttura, email, phoneNumber) {
        const url = `${this.basePath}/auth/signup`;

        const password = Math.random().toString(36).slice(-8);

        const payload = {
            user: {
                club: {
                    email: email,
                    locale: 'it-IT',
                    name: nomeStruttura,
                    phoneNumber: phoneNumber
                }
            },
            password: password
        };

        try {
            const response = await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            if (response.status === 200 || response.status === 201) {
                return response.data;
            } else {
                return { error: 'Errore generico durante l\'operazione (stato '+response.status+')' };
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: getErrorLabel(errorResponseData.detail)};
            } else {
                return {error: 'Errore generico durante l\'operazione'};
            }
        }
    }

    async getSignupTrialPricing(discountCode) {
        const url = `${this.basePath}/auth/signup-trial/pricing${discountCode ? `?discountCode=${encodeURIComponent(discountCode)}` : ''}`;
        try {
            const response = await axios.get(url, {
                headers: { 'Accept': 'application/json' },
            });
            if (response.status === 200) return response.data;
            return { error: `Errore generico durante l'operazione (stato ${response.status})` };
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            if (error.response) {
                return { error: getErrorLabel(error.response.data.detail) };
            }
            return { error: "Errore generico durante l'operazione" };
        }
    }

    async signupTrial(nomeStruttura, email, discountCode) {
        const url = `${this.basePath}/auth/signup-trial`;
        const payload = { name: nomeStruttura, email, locale: 'it-IT' };
        if (discountCode) payload.discountCode = discountCode;

        try {
            const response = await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
            });
            if (response.status === 200 || response.status === 201) {
                return response.data;
            }
            return { error: `Errore generico durante l'operazione (stato ${response.status})` };
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            if (error.response) {
                const errorResponseData = error.response.data;
                return { error: getErrorLabel(errorResponseData.detail) };
            }
            return { error: "Errore generico durante l'operazione" };
        }
    }

    async forgotpassword1(username) {
        const url = `${this.basePath}/auth/forgotPassword`;
        
        const payload = {
            username: username
        };

        try {
            const response = await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            if (response.status === 204 || response.status === 200) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async forgotpassword2(username, temporaryPassword, newPassword) {
        const url = `${this.basePath}/auth/resetPassword`;
        
        const payload = {
            username: username,
            temporaryPassword: temporaryPassword,
            newPassword: newPassword
        };

        try {
            const response = await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            if (response.status === 204 || response.status === 200) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async confirmationResend(username) {
        const url = `${this.basePath}/auth/signup/confirmationresend`;
        
        const payload = {
            email: username
        };

        try {
            const response = await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            if (response.status === 204 || response.status === 200) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async changePassword(token, accesstoken, oldpassword, newpassword) {
        const url = `${this.basePath}/auth/credentials`;
        
        const payload = {
            oldPassword: oldpassword,
            newPassword: newpassword
        };

        try {
            const response = await axios.patch(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token,
                    'access-token': accesstoken
                }
            });
            
            if (response.status === 200 || response.status === 204) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async changeEmail(token, email) {
        const url = `${this.basePath}/auth/credentials/email`;
        
        const payload = {
            email: email
        };

        try {
            const response = await axios.put(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token
                }
            });
            
            if (response.status === 200 || response.status === 204) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getProfile(token) {
        const url = `${this.basePath}/profile`;
        
        try {
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            throw error;
        }
    }

    async getPlayerLicenses(token, userId) {
        let url = `${this.basePath}/profile/playerLicenses`;
        if (userId) {
            url += `?userId=${userId}`;
        }
        
        try {
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            throw error;
        }
    }

    async getPrivateProfile(token, userId) {
        const url = `${this.basePath}/profile?userId=${userId}`;
        
        try {
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            throw error;
        }
    }

    async updateProfile(token, dataUpdate) {
        // Il super admin che modifica il profilo di un altro utente (pagine delle anagrafiche) passa dalla rotta di amministrazione
        const url = profiloDiModifica ? `${this.basePath}/administration/profiles/${encodeURIComponent(profiloDiModifica)}` : `${this.basePath}/profile`;
        
        try {
            
            let data = JSON.stringify(dataUpdate);
            
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);

            if (response.status === 200) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData);
                const errorMessage = (errorResponseData && errorResponseData.detail) 
                    ? errorResponseData.detail 
                    : `Errore server (${error.response.status})`;
                return {'error': errorMessage};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async verifyClubStripeKey(token, stripeApiKey) {
        const url = `${this.basePath}/profile/stripeVerification`;

        const payload = stripeApiKey ? { stripe_api_key: stripeApiKey } : {};

        try {
            const response = await axios.post(url, payload, {
                headers: {
                    'authorization': token,
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData);
                const errorMessage = (errorResponseData && errorResponseData.detail)
                    ? errorResponseData.detail
                    : `Errore server (${error.response.status})`;
                return {'error': errorMessage};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getAdministrationClub(token) {
        const url = `${this.basePath}/administration/club/overview`;
        
        try {
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getAdministrationClubOverviewSales(token) {
        const url = `${this.basePath}/administration/club/overview/sales`;
        
        try {
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getWalletFee(token) {
        const url = `${this.basePath}/wallet/fee`;
        
        try {
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async addCopertina(token, dataUpdate) {
        const url = `${this.basePath}/profile/pictures`;
        
        let data = JSON.stringify(dataUpdate);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);

            if (response.status === 201) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            return false;
        }
    }

    /**
     * Rimuove il tesserino di uno sport insegnato.
     *
     * `userId` lo accetta solo il superadmin, per agire sulla scheda di un
     * maestro: da chiunque altro viene ignorato e vale il proprio.
     */
    async deleteTaughtSport(token, sportType, userId = null) {
        let url = `${this.basePath}/profile/taughtSports/${sportType}`;
        if (userId) {
            url += `?userId=${encodeURIComponent(userId)}`;
        }

        try {
            const config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.request(config);
            // Il server risponde 204: niente corpo, solo l'esito.
            return response.status >= 200 && response.status < 300;
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            return false;
        }
    }

    async deleteCopertina(token,id) {
        const url = `${this.basePath}/profile/pictures/${id}`;
        
        try {
            
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);

            if (response.status === 200) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            return false;
        }
    }

    async getTitles(token, userId = null) {
        // `userId`: i titoli di un'altra struttura (solo super admin)
        const url = `${this.basePath}/profile/titles${userId ? `?userId=${encodeURIComponent(userId)}` : ''}`;
        
        try {
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async addTitle(token, dataUpdate) {
        const url = `${this.basePath}/profile/titles`;
        
        let data = JSON.stringify(dataUpdate);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);

            if (response.status === 201) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            return false;
        }
    }

    async deleteTitle(token,id) {
        const url = `${this.basePath}/profile/titles/${id}`;
        
        try {
            
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);

            if (response.status === 200) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            return false;
        }
    }

    async getWalletFitcoinsSummary(token,userId) {
        const url = `${this.basePath}/wallet/fitcoins/summary?userId=${userId}`;
        
        try {
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getCustomers(token) {
        const url = `${this.basePath}/administration/customers`;

        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getJuniors(token) {
        const url = `${this.basePath}/juniors`;

        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getMemberships(token,membershipRanks,notMembershipRanks,statusFilter) {
        let url = `${this.basePath}/memberships`;
        
        let added = false;
        if(membershipRanks) {
            if(added) {
                url+='&';
            } else {
                url+='?';
            }
            url += `membershipRanks=${membershipRanks}`;
            added = true;
        }
        if(notMembershipRanks) {
            if(added) {
                url+='&';
            } else {
                url+='?';
            }
            url += `notMembershipRanks=${notMembershipRanks}`;
            added = true;
        }
        if(statusFilter) {
            if(added) {
                url+='&';
            } else {
                url+='?';
            }
            url += `status=${statusFilter}`;
            added = true;
        }

        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getProfiles(token,id) {
        const url = `${this.basePath}/profiles/${id}`;

        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getGuruSchedules(token, guruId) {
        const url = `${this.basePath}/profile/guru/schedules/by-guru/${guruId}`;

        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async createGuruSchedule(token, scheduleData) {
        const url = `${this.basePath}/profile/guru/schedules`;

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(scheduleData)
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async updateGuruSchedule(token, scheduleId, scheduleData) {
        const url = `${this.basePath}/profile/guru/schedules/${scheduleId}`;

        try {
            
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(scheduleData)
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async deleteGuruSchedule(token, scheduleId) {
        const url = `${this.basePath}/profile/guru/schedules/${scheduleId}`;

        try {
            
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async activateGuruSchedule(token, scheduleId) {
        const url = `${this.basePath}/profile/guru/schedules/${scheduleId}/activate`;

        try {
            
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async cancelGuruSchedule(token, scheduleId, reason = '') {
        const url = `${this.basePath}/profile/guru/schedules/${scheduleId}/cancel`;

        try {
            const requestBody = reason ? { reason } : {};
            
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(requestBody)
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getProfilesByFilters(token,limit,name,type,offset=0, sort=null, sortAscending=true, filterName=null, filterEmail=null, profileStatus=null) {
        let url = `${this.basePath}/profiles?limit=${limit}&userTypes=${type}&offset=${offset}`;
        if(name) {
            url += '&user='+encodeURIComponent(name);
        }
        if(sort) {
            url += `&sort=${sort}&sortAscending=${sortAscending}`;
        }
        if(filterName) {
            url += '&user='+encodeURIComponent(filterName);
        } else if(filterEmail) {
            url += '&user='+encodeURIComponent(filterEmail);
        }
        // Uno o più stati (filtro con «Tutti»): un parametro per stato.
        const stati = Array.isArray(profileStatus) ? profileStatus : (profileStatus ? [profileStatus] : []);
        stati.forEach((stato) => {
            url += '&profileStatus='+encodeURIComponent(stato);
        });

        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getUserBookings(token, limit, offset, status = null, sortBy = null, sortOrder = null, filtri = {}) {
        let url = `${this.basePath}/booking/userBookings?limit=${limit}&offset=${offset}`;
        if (status) {
            url += `&status=${status}`;
        }
        // Senza ordinamento il server usa il suo (data ordine, dalla piu' recente).
        if (sortBy) {
            url += `&sortBy=${sortBy}`;
            url += `&sortOrder=${sortOrder === 'asc' ? 'asc' : 'desc'}`;
        }
        // Gli altri filtri: si mandano solo quelli valorizzati, e il nome del
        // cliente va codificato perche' puo' contenere spazi e accenti.
        Object.entries(filtri || {}).forEach(([nome, valore]) => {
            if (valore !== undefined && valore !== null && valore !== '') {
                url += `&${nome}=${encodeURIComponent(valore)}`;
            }
        });
        
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async inviteUser(token, clubId, dataUpdate) {
        const url = `${this.basePath}/clubs/${clubId}/inviteUsers`;
        
        let data = JSON.stringify(dataUpdate);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);

            if (response.status === 201) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async updateClubMember(token, clubId, membershipId, dataUpdate) {
        const url = `${this.basePath}/clubs/${clubId}/memberships/${membershipId}`;

        let data = JSON.stringify(dataUpdate);

        try {

            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };

            const response = await axios.request(config);

            if (response.status === 200 || response.status === 204) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getUserMemberships(token, userId) {
        const url = `${this.basePath}/profiles/${userId}/memberships`;

        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json'
                }
            };

            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async updatePlayerLicense(token, licenseId, userId, dataUpdate) {
        const url = `${this.basePath}/profile/playerLicenses/${licenseId}`;

        let data = JSON.stringify({ ...dataUpdate, userId });

        try {
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };

            const response = await axios.request(config);

            if (response.status === 200 || response.status === 204) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async deletePlayerLicense(token, sportType, userId) {
        const url = `${this.basePath}/profile/playerLicenses/${sportType}`;

        let data = JSON.stringify({ userId: userId });

        try {
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };

            const response = await axios.request(config);

            if (response.status === 200 || response.status === 204) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async addPlayerLicense(token, dataUpdate) {
        const url = `${this.basePath}/profile/playerLicenses`;

        let data = JSON.stringify(dataUpdate);

        try {

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };

            const response = await axios.request(config);

            if (response.status === 201) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async deleteClubMember(token, clubId, membershipId) {
        const url = `${this.basePath}/clubs/${clubId}/memberships/${membershipId}`;

        try {

            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json'
                }
            };

            const response = await axios.request(config);

            if (response.status === 204) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async addClubMember(token, clubId, dataUpdate) {
        const url = `${this.basePath}/clubs/${clubId}/members`;

        let data = JSON.stringify(dataUpdate);

        try {

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };

            const response = await axios.request(config);

            if (response.status === 201) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    // ************************************************************************************
    // CONSIGLIO DIRETTIVO (BOARD)
    // ************************************************************************************

    _boardConfig(method, token, url, data) {
        const config = {
            method: method,
            maxBodyLength: Infinity,
            url: url,
            headers: {
                'authorization': token,
                'accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        if (data !== undefined) config.data = JSON.stringify(data);
        return config;
    }

    async _boardRequest(method, token, url, data) {
        try {
            const response = await axios.request(this._boardConfig(method, token, url, data));
            return response.status === 204 ? {} : response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                return {error: error.response.data.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async getClubBoard(token, clubId) {
        return await this._boardRequest('get', token, `${this.basePath}/clubs/${clubId}/board`);
    }

    async addBoardMember(token, clubId, body) {
        return await this._boardRequest('post', token, `${this.basePath}/clubs/${clubId}/board`, body);
    }

    async updateBoardMember(token, clubId, membershipId, body) {
        return await this._boardRequest('patch', token, `${this.basePath}/clubs/${clubId}/board/${membershipId}`, body);
    }

    async removeBoardMember(token, clubId, membershipId) {
        return await this._boardRequest('delete', token, `${this.basePath}/clubs/${clubId}/board/${membershipId}`);
    }

    async updateBoardMemberSignature(token, clubId, membershipId, document) {
        return await this._boardRequest('put', token, `${this.basePath}/clubs/${clubId}/board/${membershipId}/signature`, { document });
    }

    async deleteBoardMemberSignature(token, clubId, membershipId) {
        return await this._boardRequest('delete', token, `${this.basePath}/clubs/${clubId}/board/${membershipId}/signature`);
    }

    async deleteMembership(token, userId, membershipRank, sportType = null) {
        let url = `${this.basePath}/profile/memberships/${userId}?membershipRank=${membershipRank}`;
        if (sportType) {
            url += `&sport=${sportType}`;
        }
        
        try {
            
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);

            if (response.status === 204) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            return false;
        }
    }

    async deleteMembershipBySport(token, userId, membershipRank, sportType) {
        const url = `${this.basePath}/profile/memberships/${userId}?membershipRank=${membershipRank}&sport=${sportType}`;
        
        try {
            
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);

            if (response.status === 204) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            return false;
        }
    }

    // `assemblyId` accompagna l'esito di una candidatura a socio: e' l'assemblea che
    // ha deliberato. Facoltativo, e il server lo rilegge per conto suo prima di
    // fidarsene, quindi qui basta passarlo.
    async updateMembership(token, userId, membershipRank, status, sportType = null, assemblyId = null) {
        let url = `${this.basePath}/club/memberships/status?userOrClubId=${userId}&membershipRank=${membershipRank}`;
        if (sportType) {
            url += `&sportType=${sportType}`;
        }
        
        const payload = {
            status: status
        };
        if (assemblyId) {
            payload.assemblyId = assemblyId;
        }

        try {
            const response = await axios.put(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token
                }
            });
            
            if (response.status === 200 || response.status === 204) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getDocuments(token) {
        const url = `${this.basePath}/profile/documents`;

        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async deleteDoc(token,id) {
        const url = `${this.basePath}/profile/documents/${id}`;
        
        try {
            
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);

            if (response.status === 200) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            return false;
        }
    }

    async addDocument(token, dataInsert) {
        const url = `${this.basePath}/profile/documents`;
        
        let data = JSON.stringify(dataInsert);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);

            if (response.status === 201) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                // Nessuna risposta: di solito il file e' troppo grande per arrivare al server
                return {'error': MESSAGGIO_CARICAMENTO_NON_RIUSCITO};
            }
        }
    }

    async getCommunications(token) {
        const url = `${this.basePath}/administration/communications?limit=1000`;

        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async addCommunication(token, dataInsert) {
        const url = `${this.basePath}/administration/communications`;
        
        let data = JSON.stringify(dataInsert);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);

            if (response.status === 204) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async deleteCommunications(token,id) {
        const url = `${this.basePath}/administration/communications/${id}`;
        
        try {
            
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);

            if (response.status === 204) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            return false;
        }
    }

    async editCommunication(token, id, dataEdit) {
        const url = `${this.basePath}/administration/communications/${id}`;
        
        let data = JSON.stringify(dataEdit);

        try {
            
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);

            if (response.status === 204) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getTeams(token,clubId) {
        const url = `${this.basePath}/clubs/${clubId}/teams`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getProfileReviews(token,userId) {
        const url = `${this.basePath}/profiles/${userId}/reviews/summary`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async createStructureTeam(token, dataCreate) {
        const url = `${this.basePath}/clubs/teams`;
        
        let data = JSON.stringify(dataCreate);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);

            if (response.status === 201) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            return false;
        }
    }

    async getTeam(token,clubId,teamId) {
        const url = `${this.basePath}/clubs/${clubId}/teams/${teamId}`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async updateStructureTeam(token, clubId, teamId, dataUpdate) {
        const url = `${this.basePath}/clubs/${clubId}/teams/${teamId}`;
        
        try {
            
            let data = JSON.stringify(dataUpdate);
            
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);

            if (response.status === 200) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getSeasonCurrentRewards(token,userId) {
        const url = `${this.basePath}/seasons/current/rewards?userId=${userId}`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getSportsSkills(token,userId) {
        const url = `${this.basePath}/sports/skills?userId=${userId}`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getAdministrationSuperAdmin(token) {
        const url = `${this.basePath}/administration/overview`;
        
        try {
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getJuniorsByParent(token,parentId) {
        const url = `${this.basePath}/juniorsbyparent/${parentId}`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async deleteProfile(token,id) {
        const url = `${this.basePath}/profile?userId=${id}`;
        
        try {
            
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);

            if (response.status === 204) {
                return "";
            } else {
                return "Errore generico durante la cancellazione";
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response.status === 500 && error.response.data.detail === "Delete player's juniors profiles before delete player's profile") {
                return "Devi cancellare gli junior collegati all'utente prima di procedere alla cancellazione dell'utente.";
            } else {
                return "Errore generico durante la cancellazione";
            }
        }
    }

    async reinviteUser(token, clubId, dataUpdate) {
        const url = `${this.basePath}/clubs/${clubId}/reinviteUsers`;
        
        let data = JSON.stringify(dataUpdate);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);

            if (response.status === 201) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getMedicalCertificatesToApprove(token) {
        const url = `${this.basePath}/administration/medicalCertificatesToApprove`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getLicensesToApprove(token) {
        const url = `${this.basePath}/administration/licensesToApprove`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getEducationsToApprove(token) {
        const url = `${this.basePath}/administration/educationsToApprove`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async approveDocument(token,documentId,verificationCode,userId,documentType) {
        
        const url = `${this.backOfficeBasePath}/backoffice/documents/${documentId}/verifications/approval?code=${verificationCode}&userId=${userId}&documentType=${documentType}`;

        try {

            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'Accept': 'text/html',
                }
            };

            const response = await axios.request(config);

            if (response.status === 200) {
                return '';
            } else {
                return {'error': 'Errore generico'};
            }

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async rejectDocument(token,documentId,verificationCode,userId,documentType) {
        
        const url = `${this.backOfficeBasePath}/backoffice/documents/${documentId}/verifications/rejection?code=${verificationCode}&userId=${userId}&documentType=${documentType}`;

        try {

            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'Accept': 'text/html',
                }
            };

            const response = await axios.request(config);

            if (response.status === 200) {
                return '';
            } else {
                return {'error': 'Errore generico'};
            }

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getClubReferral(token) {
        const url = `${this.basePath}/administration/club/referral`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getAdminReferral(token) {
        const url = `${this.basePath}/administration/admin/referral`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async addAdminReferralTransaction(token, clubId, startDate, endDate) {
        const url = `${this.basePath}/administration/admin/referraltransactions`;
        
        const data = {
            clubId: clubId,
            startDate: startDate,
            endDate: endDate
        };

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);

            if (response.status === 204) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async getClubReferralTransactions(token) {
        const url = `${this.basePath}/administration/club/referraltransactions`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    // ************************************************************************************

    async getBookingSubscriptions(token) {
        const url = `${this.basePath}/booking/subscriptions`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getBookingSubscriptionById(token, subscriptionId) {
        const url = `${this.basePath}/booking/subscriptions/${subscriptionId}`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async createBookingSubscription(token, dataCreate) {
        const url = `${this.basePath}/booking/subscriptions`;
        
        let data = JSON.stringify(dataCreate);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async deleteBookingSubscription(token, subscriptionId) {
        const url = `${this.basePath}/booking/subscriptions?subscriptionId=${subscriptionId}`;
        
        try {
            
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);

            if (response.status === 204) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            return false;
        }
    }

    async updateBookingSubscription(token, dataCreate) {
        const url = `${this.basePath}/booking/subscriptions`;
        
        let data = JSON.stringify(dataCreate);

        try {
            
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    // `archivia` (TASK #7, 23/10/2026): con CANCELLED mette il prodotto in archivio
    async changeSubscriptionStatus(token, subscriptionId, status, archivia = false) {
        const url = `${this.basePath}/booking/subscriptions/changeStatus?subscriptionId=${subscriptionId}&status=${status}${archivia ? '&archived=true' : ''}`;

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async getUserBookingSubscriptions(token, subscriptionId = null) {
        let url = `${this.basePath}/booking/userSubscriptions`;
        
        if (subscriptionId) {
            url += `?subscription_id=${subscriptionId}`;
        }
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getUserBookingSubscriptionById(token, userSubscriptionId) {
        const url = `${this.basePath}/booking/userSubscriptions/${userSubscriptionId}`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getUserBookingSubscriptionsPreview(token, playerId, juniorId, subscriptionId) {
        const url = `${this.basePath}/booking/userSubscriptions/preview`;

        const objectToSend = {playerId: playerId, subscriptionId: subscriptionId}
        if(juniorId) {
            objectToSend.juniorId = juniorId
        }

        let data = JSON.stringify(objectToSend);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async createUserBookingSubscription(token, dataCreate) {
        const url = `${this.basePath}/booking/userSubscriptions`;
        
        let data = JSON.stringify(dataCreate);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async setCancelledUserSubscription(token, userSubscriptionId, cancelNote) {
        const url = `${this.basePath}/booking/userSubscriptions/setCancelled?userSubscriptionId=${userSubscriptionId}`;

        let data = JSON.stringify({cancelNote: cancelNote});

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async setCancelledUserTransaction(token, userTransactionId) {
        const url = `${this.basePath}/booking/userTransactions/setCancelled?userTransactionId=${userTransactionId}`;

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async userTransactionStatusUpdate(token, userTransactionId, invoiceStatus) {
        const url = `${this.basePath}/booking/userTransactions/statusUpdate?userTransactionId=${userTransactionId}&invoice_status=${invoiceStatus}`;

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async getClubInvoiceDataSenders(token) {
        const url = `${this.basePath}/administration/clubinvoicedatasenders`;

        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async setPayedUserSubscription(token, userSubscriptionId, paymentMethod, skipGenerateDocument = false) {
        const url = `${this.basePath}/booking/userSubscriptions/setPayed?userSubscriptionId=${userSubscriptionId}&paymentMethod=${paymentMethod}&skip_generate_document=${skipGenerateDocument === true || skipGenerateDocument === 'true'}`;

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async setRefundedUserSubscription(token, userSubscriptionId, refundNote) {
        const url = `${this.basePath}/booking/userSubscriptions/setRefunded?userSubscriptionId=${userSubscriptionId}`;

        let data = JSON.stringify({refundNote: refundNote});

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async changeAutorenewalUserSubscription(token, userSubscriptionId, autoRenewActive) {
        const url = `${this.basePath}/booking/userSubscriptions/setPayed?userSubscriptionId=${userSubscriptionId}&autoRenewActive=${autoRenewActive}`;

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    // ************************************************************************************

    async getBookingCourses(token) {
        const url = `${this.basePath}/booking/courses`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getBookingCourseById(token, courseId) {
        const url = `${this.basePath}/booking/courses/${courseId}`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async createBookingCourse(token, dataCreate) {
        const url = `${this.basePath}/booking/courses`;
        
        let data = JSON.stringify(dataCreate);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async deleteBookingCourse(token, courseId) {
        const url = `${this.basePath}/booking/courses?courseId=${courseId}`;
        
        try {
            
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);

            if (response.status === 204) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            // Il motivo del rifiuto (iscrizioni, presenze) arriva dal server: va mostrato
            // com'e', non tradotto in un generico "non riuscito".
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async updateBookingCourse(token, dataCreate) {
        const url = `${this.basePath}/booking/courses`;
        
        let data = JSON.stringify(dataCreate);

        try {
            
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    // `archivia` (TASK #7, 23/10/2026): con CANCELLED mette il prodotto in archivio
    async changeCourseStatus(token, courseId, status, archivia = false) {
        const url = `${this.basePath}/booking/courses/changeStatus?courseId=${courseId}&status=${status}${archivia ? '&archived=true' : ''}`;

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async getUserBookingCourses(token, course_id = null) {
        let url = `${this.basePath}/booking/userCourses`;
        
        if (course_id) {
            url += `?course_id=${course_id}`;
        }
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getUserBookingCourseById(token, userCourseId) {
        const url = `${this.basePath}/booking/userCourses/${userCourseId}`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getUserBookingCoursesPreview(token, playerId, juniorId, courseId) {
        const url = `${this.basePath}/booking/userCourses/preview`;

        const objectToSend = {playerId: playerId, courseId: courseId}
        if(juniorId) {
            objectToSend.juniorId = juniorId
        }

        let data = JSON.stringify(objectToSend);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async createUserBookingCourse(token, dataCreate) {
        const url = `${this.basePath}/booking/userCourses`;
        
        let data = JSON.stringify(dataCreate);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async setCancelledUserCourse(token, userCourseId, cancelNote) {
        const url = `${this.basePath}/booking/userCourses/setCancelled?userCourseId=${userCourseId}`;

        let data = JSON.stringify({cancelNote: cancelNote});

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async setPayedUserCourse(token, userCourseId, paymentMethod, skipGenerateDocument = false) {
        const url = `${this.basePath}/booking/userCourses/setPayed?userCourseId=${userCourseId}&paymentMethod=${paymentMethod}&skip_generate_document=${skipGenerateDocument === true || skipGenerateDocument === 'true'}`;

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async setRefundedUserCourse(token, userCourseId, refundNote) {
        const url = `${this.basePath}/booking/userCourses/setRefunded?userCourseId=${userCourseId}`;

        let data = JSON.stringify({refundNote: refundNote});

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    // ************************************************************************************

    async getBookingCourseTeams(token, bookingCourseId = null) {
        let url = `${this.basePath}/booking/course-teams`;
        
        if (bookingCourseId) {
            url += `?bookingCourseId=${bookingCourseId}`;
        }
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getBookingCourseTeam(token, teamId) {
        const url = `${this.basePath}/booking/course-teams/${teamId}`;
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json'
                }
            };
            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            if (error.response) {
                return { error: error.response.data?.detail || 'Errore generico' };
            } else {
                return { error: 'Errore generico' };
            }
        }
    }

    async updateCourseTeam(token, teamId, dataUpdate) {
        const url = `${this.basePath}/booking/course-teams/${teamId}`;
        let data = JSON.stringify(dataUpdate);
        try {
            let config = {
                method: 'put',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };
            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            if (error.response) {
                return { error: error.response.data?.detail || 'Errore generico' };
            } else {
                return { error: 'Errore generico' };
            }
        }
    }

    async getBookingCourseTeamMembers(token, teamId) {
        const url = `${this.basePath}/booking/course-teams/${teamId}/members`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getTeamSlotBookings(token, teamId) {
        const url = `${this.basePath}/booking/slot-bookings/team/${teamId}`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getTeamAttendances(token, teamId) {
        const url = `${this.basePath}/booking/course-teams/${teamId}/attendances`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async createCourseTeam(token, dataCreate) {
        const url = `${this.basePath}/booking/course-teams`;
        
        let data = JSON.stringify(dataCreate);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async deleteCourseTeam(token, teamId) {
        const url = `${this.basePath}/booking/course-teams/${teamId}`;
        try {
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };
            const response = await axios.request(config);
            if (response.status === 200 || response.status === 204) {
                return true;
            } else {
                return { error: 'Errore generico' };
            }
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            if (error.response) {
                return { error: error.response.data?.detail || 'Errore generico' };
            } else {
                return { error: 'Errore generico' };
            }
        }
    }

    async addMemberToTeam(token, teamId, memberData) {
        const url = `${this.basePath}/booking/course-teams/${teamId}/members`;
        
        let data = JSON.stringify(memberData);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    // Le sedute di una squadra: si aggiunge una data fuori regola, si toglie una data, oppure
    // si rifanno tutte da un certo giorno in poi seguendo la programmazione.

    async createTeamSession(token, teamId, datiSeduta) {
        const url = `${this.basePath}/booking/course-teams/${teamId}/sessions`;
        try {
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(datiSeduta)
            };
            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            if (error.response) {
                return { error: error.response.data?.detail || 'Errore generico' };
            } else {
                return { error: 'Errore generico' };
            }
        }
    }

    async deleteTeamSession(token, teamId, sessionId) {
        const url = `${this.basePath}/booking/course-teams/${teamId}/sessions/${sessionId}`;
        try {
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json'
                }
            };
            const response = await axios.request(config);
            return response.status === 200 || response.status === 204 ? true : { error: 'Errore generico' };
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            if (error.response) {
                return { error: error.response.data?.detail || 'Errore generico' };
            } else {
                return { error: 'Errore generico' };
            }
        }
    }

    async realignTeamSessions(token, teamId, datiRiallineamento) {
        const url = `${this.basePath}/booking/course-teams/${teamId}/sessions/realign`;
        try {
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(datiRiallineamento)
            };
            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            if (error.response) {
                return { error: error.response.data?.detail || 'Errore generico' };
            } else {
                return { error: 'Errore generico' };
            }
        }
    }

    async removeMemberFromTeam(token, teamId, userId) {
        const url = `${this.basePath}/booking/course-teams/${teamId}/members/${userId}`;
        try {
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json'
                }
            };
            const response = await axios.request(config);
            return response.status === 200 || response.status === 204 ? true : { error: 'Errore generico' };
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            if (error.response) {
                return { error: error.response.data?.detail || 'Errore generico' };
            } else {
                return { error: 'Errore generico' };
            }
        }
    }

    // ************************************************************************************

    async getUserBookingTransactions(token) {
        const url = `${this.basePath}/booking/userTransactions`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async sdiResendInvoice(token, transactionId) {
        const url = `${this.basePath}/sdi/resend/${transactionId}`;

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async downloadTransactionXml(token, userTransactionId) {
        const url = `${this.basePath}/booking/userTransactions/downloadXml?userTransactionId=${userTransactionId}`;

        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async getUserBookingTransactionById(token, userTransactionId) {
        const url = `${this.basePath}/booking/userTransactions/${userTransactionId}`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async updateBookingTransaction(token, dataCreate) {
        const url = `${this.basePath}/booking/userTransactions`;
        
        let data = JSON.stringify(dataCreate);

        try {
            
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async getClubPlayerInvoiceDataReceiver(token, playerId) {
        const url = `${this.basePath}/booking/club/player/${playerId}/invoiceDataReceiver`;
        try {
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async updateClubPlayerInvoiceDataReceiver(token, playerId, dataUpdate) {
        const url = `${this.basePath}/booking/club/player/${playerId}/invoiceDataReceiver`;
        let data = JSON.stringify(dataUpdate);

        try {
            let config = {
                method: 'put',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async clubRegenerateTransactionInvoice(token, transactionId) {
        const url = `${this.basePath}/booking/transaction/${transactionId}/regenerate`;
        try {
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async bulkCreatePlayers(token, players) {
        const url = `${this.basePath}/auth/players/bulk`;
        
        let data = JSON.stringify({ players: players });

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async createTemporaryPlayer(token, { givenName, familyName, email, phoneNumber, birthdate, birthPlace, taxCode, address, sports }) {
        const url = `${this.basePath}/auth/players/temporary`;

        let data = JSON.stringify({ givenName, familyName, email, phoneNumber, birthdate, birthPlace, taxCode, address, ...(sports && sports.length > 0 ? { sports } : {}) });

        try {

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };

            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async createClubJunior(token, { parentId, junior, password }) {
        const url = `${this.basePath}/clubs/juniors`;

        let data = JSON.stringify({ parentId, junior, password });

        try {

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };

            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                return {error: errorResponseData};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async convertPlayers(userId, clubId, phoneNumber, email) {
        const url = `${this.basePath}/auth/players/convert`;
        
        let data = JSON.stringify({ userId: userId, clubId: clubId, phoneNumber: phoneNumber, email: email });

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async manageInvite(userId, clubId, phoneNumber, email, accepted) {
        const url = `${this.basePath}/auth/players/manageInvite`;
        
        let data = JSON.stringify({ userId: userId, clubId: clubId, phoneNumber: phoneNumber, email: email, accepted: accepted });

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    // ************************************************************************************
    // VENUES MANAGEMENT
    // ************************************************************************************

    async getVenues(token) {
        const url = `${this.basePath}/profile/venues`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }



    async createVenue(token, venueData) {
        const url = `${this.basePath}/profile/venues`;
        
        let data = JSON.stringify(venueData);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async updateVenue(token, venueId, venueData) {
        const url = `${this.basePath}/profile/venues/${venueId}`;
        
        let data = JSON.stringify(venueData);

        try {
            
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async deleteVenue(token, venueId) {
        const url = `${this.basePath}/profile/venues/${venueId}`;
        
        try {
            
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async getVenueSchedules(token, venueId) {
        const url = `${this.basePath}/profile/venue-opening-hours/by-venue/${venueId}`;
        
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async createVenueSchedule(token, scheduleData) {
        const url = `${this.basePath}/profile/venue-opening-hours`;
        
        try {
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                },
                data: JSON.stringify(scheduleData)
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async updateVenueSchedule(token, scheduleId, scheduleData) {
        const url = `${this.basePath}/profile/venue-opening-hours/${scheduleId}`;
        
        try {
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                },
                data: JSON.stringify(scheduleData)
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async deleteVenueSchedule(token, scheduleId) {
        const url = `${this.basePath}/profile/venue-opening-hours/${scheduleId}`;
        
        try {
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async activateVenueSchedule(token, scheduleId) {
        const url = `${this.basePath}/profile/venue-opening-hours/${scheduleId}/activate`;
        
        try {
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async cancelVenueSchedule(token, scheduleId, reason = '') {
        const url = `${this.basePath}/profile/venue-opening-hours/${scheduleId}/cancel`;
        
        try {
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                },
                data: JSON.stringify({ reason })
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async getFederations(token) {
        const url = `${this.basePath}/administration/federations`;
        
        try {
            const response = await axios.get(url, {
                headers: {
                    'authorization': token,
                    'Accept': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async checkCourseConflicts(token, conflictData) {
        const url = `${this.basePath}/booking/courses/preview-schedule`;
        
        try {
            const response = await axios.post(url, conflictData, {
                headers: {
                    'authorization': token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async getSoci(token) {
        const url = `${this.basePath}/administration/customers/soci`;

        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    _tesseratiQuery(filters = {}) {
        const params = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
            if (value === undefined || value === null || value === '') return;
            params.append(key, value);
        });
        return params.toString();
    }

    // L'export e' un XLSX generato dal backend: i dati anagrafici del tracciato
    // (nascita, CF, residenza) non sono nella lista e non ha senso trasferirli.
    async exportTesserati(token, filters = {}) {
        const query = this._tesseratiQuery(filters);
        const url = `${this.basePath}/administration/customers/tesserati/export${query ? '?' + query : ''}`;

        try {
            const response = await axios.request({
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 'authorization': token, 'accept': XLSX_MIME },
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            return {error: 'Errore durante l\'esportazione'};
        }
    }

    async getTesserati(token, filters = {}) {
        const query = this._tesseratiQuery({ offset: 0, limit: 20, ...filters });
        const url = `${this.basePath}/administration/customers/tesserati?${query}`;

        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    // ************************************************************************************
    // LIBRO SOCI (MEMBER BOOK)
    // ************************************************************************************

    // Il clubId non e' nel path: il backend lo ricava dal token.
    _memberBookConfig(method, token, url, data) {
        const config = {
            method: method,
            maxBodyLength: Infinity,
            url: url,
            headers: {
                'authorization': token,
                'accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        if (data !== undefined) config.data = data;
        return config;
    }

    _memberBookQuery(filters = {}) {
        const params = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
            if (value === undefined || value === null || value === '') return;
            params.append(key, value);
        });
        return params.toString();
    }

    async getMemberBook(token, filters = {}) {
        const query = this._memberBookQuery({ offset: 0, limit: 20, ...filters });
        const url = `${this.basePath}/member-book?${query}`;

        try {
            const response = await axios.request(this._memberBookConfig('get', token, url));
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                return {error: error.response.data.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async getMemberBookEntry(token, membershipId) {
        const url = `${this.basePath}/member-book/${membershipId}`;

        try {
            const response = await axios.request(this._memberBookConfig('get', token, url));
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                return {error: error.response.data.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async updateMemberBookEntry(token, membershipId, body) {
        const url = `${this.basePath}/member-book/${membershipId}`;

        try {
            const response = await axios.request(this._memberBookConfig('patch', token, url, body));
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                return {error: error.response.data.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    // Chiusura: registra la data di uscita, non rimuove il socio dal libro.
    async closeMemberBookEntry(token, membershipId, bookStatus, date) {
        const query = this._memberBookQuery({ bookStatus, date });
        const url = `${this.basePath}/member-book/${membershipId}${query ? '?' + query : ''}`;

        try {
            await axios.request(this._memberBookConfig('delete', token, url));
            return {};
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                return {error: error.response.data.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    // Cancellazione definitiva: ammessa solo entro 7 giorni dalla creazione.
    async deleteMemberBookRecord(token, membershipId) {
        const url = `${this.basePath}/member-book/${membershipId}/record`;

        try {
            await axios.request(this._memberBookConfig('delete', token, url));
            return {};
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                return {error: error.response.data.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async reactivateMember(token, body) {
        const url = `${this.basePath}/member-book/reactivate`;

        try {
            const response = await axios.request(this._memberBookConfig('post', token, url, body));
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                return {error: error.response.data.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async sendMemberExpiryNotifications(token, body) {
        const url = `${this.basePath}/member-book/expiry-notifications`;

        try {
            const response = await axios.request(this._memberBookConfig('post', token, url, body));
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                return {error: error.response.data.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    // Risposta binaria: serve responseType blob, non JSON.
    // «Elimina socio» (21/10/2026): entro 7 giorni dall'inserimento cancella; dopo archivia (conservazione 10 anni).
    async deleteMemberBookEntry(token, membershipId) {
        const url = `${this.basePath}/member-book/${membershipId}/record`;

        try {
            await axios.request(this._memberBookConfig('delete', token, url));
            return {};
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                return {error: error.response.data.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async exportMemberBook(token, filters = {}) {
        const query = this._memberBookQuery(filters);
        const url = `${this.basePath}/member-book/export${query ? '?' + query : ''}`;

        try {
            const config = this._memberBookConfig('get', token, url);
            config.headers.accept = XLSX_MIME;
            config.responseType = 'blob';
            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            return {error: 'Errore durante l\'esportazione'};
        }
    }

    async getClubNumbering(token) {
        const url = `${this.basePath}/member-book/numbering`;

        try {
            const response = await axios.request(this._memberBookConfig('get', token, url));
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                return {error: error.response.data.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async updateClubNumbering(token, body) {
        const url = `${this.basePath}/member-book/numbering`;

        try {
            const response = await axios.request(this._memberBookConfig('put', token, url, body));
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                return {error: error.response.data.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }


    // ************************************************************************************
    // VENUE BOOKING METHODS
    // ************************************************************************************

    async getUserBookingVenues(token, venue_id = null) {
        let url = `${this.basePath}/booking/userVenues`;
        
        if (venue_id) {
            url += `?venue_id=${venue_id}`;
        }
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getUserBookingVenueById(token, userVenueId) {
        const url = `${this.basePath}/booking/userVenues/${userVenueId}`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getVenueAvailability(token, date, sportType, clubId) {
        try {
            let url = `${this.basePath}/profile/venues/availability?date=${date}&sportType=${sportType}&clubId=${clubId}`;
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    // Calendario disponibilità/occupazioni impianti per data e (opzionale) venue_id
    async getVenuesCalendar(token, date, venueId = null) {
        try {
            let url = `${this.basePath}/profile/venues/calendar?date=${date}`;
            if (venueId) {
                url += `&venue_id=${venueId}`;
            }

            const config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json'
                }
            };

            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return { error: errorResponseData.detail };
            } else {
                return { error: 'Errore generico' };
            }
        }
    }

    async getUserBookingVenuesPreview(token, playerId, juniorId, venueId) {
        
        const objectToSend = {playerId: playerId, venueId: venueId}
        if(juniorId) {
            objectToSend.juniorId = juniorId
        }

        let data = JSON.stringify(objectToSend);
        
        try {

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${this.basePath}/booking/userVenues/preview`,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async createUserBookingVenue(token, bookingData) {
        try {
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${this.basePath}/booking/userVenues`,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: bookingData
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async setCancelledUserVenue(token, userVenueId, cancelNote) {
        try {
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${this.basePath}/booking/userVenues/setCancelled?userVenueId=${userVenueId}`,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: {
                    cancelNote: cancelNote
                }
            };
            
            const response = await axios.request(config);
            return response;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async setPayedUserVenue(token, userVenueId, paymentMethod, skipGenerateDocument = false) {
        try {
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${this.basePath}/booking/userVenues/setPayed?userVenueId=${userVenueId}&paymentMethod=${paymentMethod}&skip_generate_document=${skipGenerateDocument === true || skipGenerateDocument === 'true'}`,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async setRefundedUserVenue(token, userVenueId, refundNote) {
        try {
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${this.basePath}/booking/userVenues/setRefunded?userVenueId=${userVenueId}`,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: {
                    refundNote: refundNote
                }
            };
            
            const response = await axios.request(config);
            return response;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    // ************************************************************************************
    // LESSON BOOKING METHODS
    // ************************************************************************************

    async getUserBookingLessons(token, lesson_id = null) {
        let url = `${this.basePath}/booking/userLessons`;
        
        if (lesson_id) {
            url += `?lesson_id=${lesson_id}`;
        }
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getUserBookingLessonById(token, userLessonId) {
        const url = `${this.basePath}/booking/userLessons/${userLessonId}`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getLessonAvailability(token, date, sportType, clubId) {
        try {
            let url = `${this.basePath}/booking/userLessons/availability?date=${date}&sportType=${sportType}&clubId=${clubId}`;
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async getUserLessonsCalendar(token, date, lessonId = null) {
        try {
            let url = `${this.basePath}/booking/userLessons/calendar?date=${date}`;
            if (lessonId) {
                url += `&lesson_id=${lessonId}`;
            }

            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json'
                }
            };

            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async getUserBookingLessonsPreview(token, playerId, juniorId, lessonId) {
        
        const objectToSend = {playerId: playerId, lessonId: lessonId}
        if(juniorId) {
            objectToSend.juniorId = juniorId
        }

        let data = JSON.stringify(objectToSend);
        
        try {

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${this.basePath}/booking/userLessons/preview`,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async createUserBookingLesson(token, bookingData) {
        try {
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${this.basePath}/booking/userLessons`,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: bookingData
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async setCancelledUserLesson(token, userLessonId, cancelNote) {
        try {
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${this.basePath}/booking/userLessons/setCancelled?userLessonId=${userLessonId}`,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: {
                    cancelNote: cancelNote
                }
            };
            
            const response = await axios.request(config);
            return response;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async setPayedUserLesson(token, userLessonId, paymentMethod, skipGenerateDocument = false) {
        try {
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${this.basePath}/booking/userLessons/setPayed?userLessonId=${userLessonId}&paymentMethod=${paymentMethod}&skip_generate_document=${skipGenerateDocument === true || skipGenerateDocument === 'true'}`,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async setRefundedUserLesson(token, userLessonId, refundNote) {
        try {
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${this.basePath}/booking/userLessons/setRefunded?userLessonId=${userLessonId}`,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: {
                    refundNote: refundNote
                }
            };
            
            const response = await axios.request(config);
            return response;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async getBookingLessons(token) {
        const url = `${this.basePath}/booking/lessons`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getBookingLessonById(token, lessonId) {
        const url = `${this.basePath}/booking/lessons/${lessonId}`;
        
        try {
            
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response.data;
            
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async createBookingLesson(token, dataCreate) {
        const url = `${this.basePath}/booking/lessons`;
        
        let data = JSON.stringify(dataCreate);

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async createBookingLessonMultiple(token, dataCreateArray) {
        const url = `${this.basePath}/booking/lessons/multiple`;

        let data = JSON.stringify(dataCreateArray);

        try {
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async updateBookingLessonMultiple(token, dataUpdateArray) {
        const url = `${this.basePath}/booking/lessons/multiple`;

        let data = JSON.stringify(dataUpdateArray);

        try {
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };

            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async deleteBookingLesson(token, lessonId) {
        const url = `${this.basePath}/booking/lessons?lessonId=${lessonId}`;
        
        try {
            
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json'
                }
            };
            
            const response = await axios.request(config);

            if (response.status === 204) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            return false;
        }
    }

    async updateBookingLesson(token, dataCreate) {
        const url = `${this.basePath}/booking/lessons`;
        
        let data = JSON.stringify(dataCreate);

        try {
            
            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                },
                data: data
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    // `archivia` (TASK #7, 23/10/2026): con CANCELLED mette la lezione in archivio
    async changeLessonStatus(token, lessonId, status, groupId, archivia = false) {
        let url = `${this.basePath}/booking/lessons/changeStatus?status=${status}${archivia ? '&archived=true' : ''}`;
        if (lessonId) {
            url += `&lessonId=${lessonId}`;
        }
        if (groupId) {
            url += `&groupId=${groupId}`;
        }

        try {
            
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'authorization': token, 
                    'accept': 'application/json', 
                    'Content-Type': 'application/json'
                }
            };
            
            const response = await axios.request(config);
            return response;

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {error: errorResponseData.detail};
            } else {
                return {error: 'Errore generico'};
            }
        }
    }

    async updateAdministrationClubInvoiceDataSenderStatus(token, status, userId, rejectionMessage) {
        const url = `${this.basePath}/administration/clubinvoicedatasenders`;
        
        const payload = {
            status: status,
            userId: userId,
            rejectionMessage: rejectionMessage
        };

        try {
            const response = await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token
                }
            });
            
            if (response.status === 204 || response.status === 200) {
                return response;
            } else {
                return {'error': 'Errore generico'};
            }

        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData);
                const errorMessage = (errorResponseData && errorResponseData.detail) 
                    ? errorResponseData.detail 
                    : `Errore server (${error.response.status})`;
                return {'error': errorMessage};
            } else {
                return {'error': 'Errore generico'};
            }
        }
    }

    async getCalendarioRisorse(token, da, a) {
        try {
            const res = await axios.get(`${this.basePath}/calendario/risorse`, {
                params: { da, a },
                headers: { Authorization: token, Accept: 'application/json' },
            });
            return res.data;
        } catch (error) {
            return { error: error.response?.data?.detail || 'Errore generico' };
        }
    }

    async getCalendarioEventi(token, da, a, filters = {}) {
        try {
            const res = await axios.get(`${this.basePath}/calendario/eventi`, {
                params: { da, a, ...filters },
                headers: { Authorization: token, Accept: 'application/json' },
            });
            return res.data;
        } catch (error) {
            return { error: error.response?.data?.detail || 'Errore generico' };
        }
    }

    async getCalendarioEventoById(token, eventoId) {
        try {
            const res = await axios.get(`${this.basePath}/calendario/eventi/${eventoId}`, {
                headers: { Authorization: token, Accept: 'application/json' },
            });
            return res.data;
        } catch (error) {
            return { error: error.response?.data?.detail || 'Errore generico' };
        }
    }

    async createCalendarioEvento(token, body) {
        try {
            const res = await axios.post(`${this.basePath}/calendario/eventi`, body, {
                headers: { Authorization: token, Accept: 'application/json', 'Content-Type': 'application/json' },
            });
            return res.data;
        } catch (error) {
            return { error: error.response?.data?.detail || 'Errore generico' };
        }
    }

    async updateCalendarioEvento(token, eventoId, body) {
        try {
            const res = await axios.put(`${this.basePath}/calendario/eventi/${eventoId}`, body, {
                headers: { Authorization: token, Accept: 'application/json', 'Content-Type': 'application/json' },
            });
            return res.data;
        } catch (error) {
            return { error: error.response?.data?.detail || 'Errore generico' };
        }
    }

    async deleteCalendarioEvento(token, eventoId) {
        try {
            const res = await axios.delete(`${this.basePath}/calendario/eventi/${eventoId}`, {
                headers: { Authorization: token, Accept: 'application/json' },
            });
            return res.data;
        } catch (error) {
            return { error: error.response?.data?.detail || 'Errore generico' };
        }
    }

    async rescheduleCalendarioEvento(token, eventoId, payload) {
        try {
            const res = await axios.post(
                `${this.basePath}/calendario/eventi/${eventoId}/reschedule`,
                payload,
                { headers: { Authorization: token, Accept: 'application/json', 'Content-Type': 'application/json' } }
            );
            return res.data;
        } catch (error) {
            return { error: error.response?.data?.detail || error.response?.data?.error || 'Errore generico' };
        }
    }

    async registraPagamentoPartecipante(token, eventoId, partecipanteId, pagato) {
        try {
            const res = await axios.post(
                `${this.basePath}/calendario/eventi/${eventoId}/partecipanti/${partecipanteId}/pagamento`,
                { pagato },
                { headers: { Authorization: token, Accept: 'application/json', 'Content-Type': 'application/json' } }
            );
            return res.data;
        } catch (error) {
            return { error: error.response?.data?.detail || 'Errore generico' };
        }
    }
    // --- Assemblee (TASK #11) ---
    //
    // Tutte le rotte stanno sotto /assemblies: il clubId non compare nell'url,
    // lo ricava il backend dal token, come per il libro soci.

    _assembliesConfig(method, token, url, data) {
        const config = {
            method: method,
            maxBodyLength: Infinity,
            url: url,
            headers: {
                'authorization': token,
                'accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        if (data !== undefined) config.data = data;
        return config;
    }

    // I valori vuoti non diventano parametri: `type=` filtrerebbe sulle assemblee
    // di tipo stringa vuota invece che su tutte. `status` è ripetibile, quindi un
    // array diventa più parametri con lo stesso nome.
    _assembliesQuery(filters = {}) {
        const params = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
            if (value === undefined || value === null || value === '') return;
            if (Array.isArray(value)) {
                value.forEach(v => params.append(key, v));
                return;
            }
            params.append(key, value);
        });
        return params.toString();
    }

    async _assembliesRequest(method, token, url, data) {
        try {
            const response = await axios.request(this._assembliesConfig(method, token, url, data));
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            if (error.response) {
                return { error: error.response.data.detail || error.response.data.title || 'Errore generico' };
            }
            return { error: 'Errore generico' };
        }
    }

    async listAssemblies(token, filters = {}) {
        const query = this._assembliesQuery({ offset: 0, limit: 20, ...filters });
        return await this._assembliesRequest('get', token, `${this.basePath}/assemblies?${query}`);
    }

    async getAssembly(token, assemblyId) {
        return await this._assembliesRequest('get', token, `${this.basePath}/assemblies/${assemblyId}`);
    }

    async createAssembly(token, body) {
        return await this._assembliesRequest('post', token, `${this.basePath}/assemblies`, body);
    }

    async updateAssembly(token, assemblyId, body) {
        return await this._assembliesRequest('patch', token, `${this.basePath}/assemblies/${assemblyId}`, body);
    }

    async deleteAssembly(token, assemblyId) {
        return await this._assembliesRequest('delete', token, `${this.basePath}/assemblies/${assemblyId}`);
    }

    async archiveAssembly(token, assemblyId, archived) {
        return await this._assembliesRequest('post', token, `${this.basePath}/assemblies/${assemblyId}/archive`, { archived });
    }
    async sendAssemblyNotice(token, assemblyId, userIds) {
        return await this._assembliesRequest('post', token, `${this.basePath}/assemblies/${assemblyId}/send`, { userIds });
    }

    async listAssemblyInvitees(token, assemblyId, filters = {}) {
        const query = this._assembliesQuery({ offset: 0, limit: 10, ...filters });
        return await this._assembliesRequest('get', token, `${this.basePath}/assemblies/${assemblyId}/invitees?${query}`);
    }

    // Una riga alla volta: con l'elenco paginato il client non ha piu' l'insieme
    // completo, quindi rispedire l'array intero cancellerebbe le presenze delle
    // pagine mai visitate. La risposta porta i conteggi aggiornati del quorum.
    async setInviteeAttendance(token, assemblyId, userId, present) {
        return await this._assembliesRequest('put', token, `${this.basePath}/assemblies/${assemblyId}/invitees/${userId}/attendance`, { present });
    }

    // Il "seleziona tutti": lo fa il server su tutti i convocati, non il client
    // riga per riga su quelle che vede.
    async setAllAttendance(token, assemblyId, present) {
        return await this._assembliesRequest('put', token, `${this.basePath}/assemblies/${assemblyId}/attendance`, { present });
    }

    async listAssemblyProxies(token, assemblyId, filters = {}) {
        const query = this._assembliesQuery({ offset: 0, limit: 50, ...filters });
        return await this._assembliesRequest('get', token, `${this.basePath}/assemblies/${assemblyId}/proxies?${query}`);
    }

    async addAssemblyProxy(token, assemblyId, body) {
        return await this._assembliesRequest('post', token, `${this.basePath}/assemblies/${assemblyId}/proxies`, body);
    }

    async deleteAssemblyProxy(token, assemblyId, proxyId) {
        return await this._assembliesRequest('delete', token, `${this.basePath}/assemblies/${assemblyId}/proxies/${proxyId}`);
    }

    async registerAssemblyOutcome(token, assemblyId, outcome) {
        return await this._assembliesRequest('post', token, `${this.basePath}/assemblies/${assemblyId}/outcome`, { outcome });
    }

    async upsertAssemblyMinutes(token, assemblyId, body) {
        return await this._assembliesRequest('put', token, `${this.basePath}/assemblies/${assemblyId}/minutes`, body);
    }

    async finalizeAssemblyMinutes(token, assemblyId) {
        return await this._assembliesRequest('post', token, `${this.basePath}/assemblies/${assemblyId}/minutes/finalize`);
    }

    // Il verbale definitivo, in PDF allegato, ai soci convocati che non erano presenti (TASK #11, 21/10/2026)
    async sendAssemblyMinutesToAbsentees(token, assemblyId) {
        return await this._assembliesRequest('post', token, `${this.basePath}/assemblies/${assemblyId}/minutes/distribution`);
    }

    // Gli allegati della convocazione restano agli atti: non partono nella mail
    // ai soci, si elencano in fondo al PDF.
    async uploadNoticeAttachment(token, assemblyId, document) {
        return await this._assembliesRequest('post', token, `${this.basePath}/assemblies/${assemblyId}/notice/attachments`, { document });
    }

    async deleteNoticeAttachment(token, assemblyId, attachmentId) {
        return await this._assembliesRequest('delete', token, `${this.basePath}/assemblies/${assemblyId}/notice/attachments/${attachmentId}`);
    }

    async uploadMinutesAttachment(token, assemblyId, document) {
        return await this._assembliesRequest('post', token, `${this.basePath}/assemblies/${assemblyId}/minutes/attachments`, { document });
    }

    async deleteMinutesAttachment(token, assemblyId, attachmentId) {
        return await this._assembliesRequest('delete', token, `${this.basePath}/assemblies/${assemblyId}/minutes/attachments/${attachmentId}`);
    }

    // I due PDF: risposta binaria, serve responseType blob.
    //
    // E serve anche chiedere `Accept: application/pdf`. API Gateway decide se la
    // risposta e' binaria guardando l'Accept della richiesta, e ne legge solo il
    // primo valore: con `application/json` rispedisce il base64 della Lambda come
    // testo, e quello che arriva al browser non e' un PDF.
    async _assemblyPdf(token, url) {
        try {
            const config = this._assembliesConfig('get', token, url);
            config.headers.accept = 'application/pdf';
            config.responseType = 'blob';
            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            return { error: 'Errore durante la generazione del PDF' };
        }
    }

    async downloadAssemblyNotice(token, assemblyId) {
        return await this._assemblyPdf(token, `${this.basePath}/assemblies/${assemblyId}/notice-pdf`);
    }

    async downloadAssemblyMinutes(token, assemblyId) {
        return await this._assemblyPdf(token, `${this.basePath}/assemblies/${assemblyId}/minutes-pdf`);
    }

    // --- Modelli di convocazione, sempre per club ---
    //
    // Il club parte senza nessuno: si riempiono quando si salva una convocazione
    // gia' scritta come modello.

    async listAssemblyTemplates(token) {
        const query = this._assembliesQuery({ limit: 50 });
        return await this._assembliesRequest('get', token, `${this.basePath}/assemblies/templates?${query}`);
    }

    async createAssemblyTemplate(token, body) {
        return await this._assembliesRequest('post', token, `${this.basePath}/assemblies/templates`, body);
    }

    async deleteAssemblyTemplate(token, templateId) {
        return await this._assembliesRequest('delete', token, `${this.basePath}/assemblies/templates/${templateId}`);
    }

    // --- Catalogo discipline sportive ---
    //
    // Prima erano un elenco compilato dentro `Util/enum.js`, e aggiungerne una voleva
    // dire un rilascio. Adesso stanno a DB: qui sotto la lettura, che serve a tutti, e
    // il CRUD, che serve solo al Superadmin.

    async _sportsRequest(method, token, url, data) {
        try {
            const config = {
                method,
                maxBodyLength: Infinity,
                url,
                headers: {
                    'authorization': token,
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };
            if (data !== undefined) config.data = data;
            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            if (error.response) {
                const data = error.response.data || {};
                return { error: data.detail || data.title || 'Errore generico', status: error.response.status };
            }
            return { error: 'Errore generico' };
        }
    }

    async getSportsCatalog(token, includeInactive = false) {
        const query = includeInactive ? '?includeInactive=true' : '';
        return await this._sportsRequest('get', token, `${this.basePath}/sports/catalog${query}`);
    }

    async getAdminSports(token) {
        return await this._sportsRequest('get', token, `${this.basePath}/administration/sports`);
    }

    async createAdminSport(token, body) {
        return await this._sportsRequest('post', token, `${this.basePath}/administration/sports`, body);
    }

    async updateAdminSport(token, code, body) {
        return await this._sportsRequest('patch', token, `${this.basePath}/administration/sports/${code}`, body);
    }

    async deleteAdminSport(token, code) {
        return await this._sportsRequest('delete', token, `${this.basePath}/administration/sports/${code}`);
    }

    // --- Traguardi (move-goals) di una disciplina, solo Superadmin ---
    // `code` puo' essere GLOBAL: i traguardi validi per tutte le discipline.

    async getAdminMoveGoals(token, code) {
        return await this._sportsRequest('get', token, `${this.basePath}/administration/sports/${code}/moveGoals`);
    }

    async createAdminMoveGoal(token, code, body) {
        return await this._sportsRequest('post', token, `${this.basePath}/administration/sports/${code}/moveGoals`, body);
    }

    async updateAdminMoveGoal(token, moveGoalId, body) {
        return await this._sportsRequest('patch', token, `${this.basePath}/administration/moveGoals/${encodeURIComponent(moveGoalId)}`, body);
    }

    async deleteAdminMoveGoal(token, moveGoalId) {
        return await this._sportsRequest('delete', token, `${this.basePath}/administration/moveGoals/${encodeURIComponent(moveGoalId)}`);
    }

    /**
     * Link d'acquisto pubblici dei prodotti della struttura (productType: 'course' | 'subscription'
     * | 'lesson' | 'venue'). Un prodotto può avere più link, ognuno con nota, stato, viste e vendite.
     */
    // I link d'acquisto generati dalla struttura (data, prodotto, viste, vendite, stato, nota), dal più recente.
    // Con { productType, productId } solo quelli di un prodotto (la finestra della scheda prodotto).
    async getPurchaseLinks(token, filtro = {}) {
        try {
            const response = await axios.request({
                method: 'get',
                url: `${this.basePath}/booking/purchaseLinks`,
                headers: { 'authorization': token, 'accept': 'application/json' },
                params: filtro,
            });
            return Array.isArray(response.data) ? response.data : (response.data?.items || []);
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            return { 'error': error.response?.data?.detail || 'Elenco dei link non disponibile.', 'status': error.response?.status };
        }
    }

    // Stato (ACTIVE / DISABLED) e nota di un link d'acquisto.
    async updatePurchaseLink(token, linkToken, data) {
        try {
            const response = await axios.request({
                method: 'patch',
                url: `${this.basePath}/booking/purchaseLinks/${encodeURIComponent(linkToken)}`,
                headers: { 'authorization': token, 'accept': 'application/json', 'content-type': 'application/json' },
                data,
            });
            return response.data || {};
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            return { 'error': error.response?.data?.detail || 'Non è stato possibile salvare il link.', 'status': error.response?.status };
        }
    }

    // Cancella un link d'acquisto: il backend lo permette solo se non ha né viste né vendite (altrimenti si disattiva).
    async deletePurchaseLink(token, linkToken) {
        try {
            await axios.request({
                method: 'delete',
                url: `${this.basePath}/booking/purchaseLinks/${encodeURIComponent(linkToken)}`,
                headers: { 'authorization': token, 'accept': 'application/json' },
            });
            return {};
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            return { 'error': error.response?.data?.detail || 'Non è stato possibile rimuovere il link.', 'status': error.response?.status };
        }
    }

    // Crea un nuovo link d'acquisto per il prodotto: un prodotto può averne più d'uno, ognuno con titolo (obbligatorio) e nota.
    async createPurchaseLink(token, productType, productId, { title, note = '', perTuttiIMaestri = false }) {
        try {
            const response = await axios.request({
                method: 'post',
                url: `${this.basePath}/booking/purchaseLinks`,
                headers: { 'authorization': token, 'accept': 'application/json', 'content-type': 'application/json' },
                // perTuttiIMaestri: lezione con piu' maestri, un link per tutto il gruppo (15/10/2026)
                data: { productType, productId, title, ...(note ? { note } : {}), ...(perTuttiIMaestri ? { perTuttiIMaestri: true } : {}) },
            });
            return response.data;
        } catch (error) {
            console.error('Error in MyApiClient: ' + error);
            return { 'error': error.response?.data?.detail || 'Non è stato possibile creare il link d’acquisto.' };
        }
    }
}
